import { Note } from '../../types/notes';

const WORDS_PER_MINUTE = 200;

/** Minutes to read a transcription (≥ 1), or 0 when there is nothing to read. */
export function readingMinutes(content: string | null): number {
  const words = (content ?? '').match(/[\p{L}\p{N}]+/gu)?.length ?? 0;
  return words === 0 ? 0 : Math.ceil(words / WORDS_PER_MINUTE);
}

/** "Sep 28, 2026 · 2 min read" — mirrors mobile/src/features/notes/note-copy.ts. */
export function metaParts(note: Pick<Note, 'created_at' | 'content'>): string[] {
  const parts = [
    new Date(note.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }),
  ];
  const minutes = readingMinutes(note.content);
  if (minutes > 0) parts.push(`${minutes} min read`);
  return parts;
}
